"use client";

import { useState } from "react";
import classNames from "classnames/bind";
import styles from "./NewsletterForm.module.css";

const cx = classNames.bind(styles);

const SUBSCRIBE_SOURCE = "website_newsletter_form";

export function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess(false);

    try {
      const res = await fetch("https://api.nlx.ai/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          source: SUBSCRIBE_SOURCE,
        }),
      });

      if (res.ok) {
        setSuccess(true);
        setEmail("");
      } else {
        setError("There was an error subscribing. Please try again.");
      }
    } catch {
      setError("Network error. Please try again later.");
    }
    setLoading(false);
  }

  return (
    <form
      className="newsletter-form"
      id="newsletter-form"
      onSubmit={handleSubmit}
      autoComplete="off"
    >
      <label htmlFor="newsletter-email" className={cx("nav-list-title")}>
        Subscribe to our newsletter
      </label>
      <div className={cx("input-wrapper")}>
        <input
          type="email"
          id="newsletter-email"
          className={cx("input")}
          placeholder="Your email address"
          aria-describedby="email-error"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button
          aria-label="Confirm newsletter signup"
          className={cx("button")}
          type="submit"
          disabled={loading}
        >
          <span className={cx("button-icon")}>
            <svg
              className=""
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              fill="none"
            >
              <path
                fill="currentColor"
                d="M13.47 8.53a.75.75 0 1 1 1.06-1.06l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 1 1-1.06-1.06l2.72-2.72H6.5a.75.75 0 1 1 0-1.5h9.69l-2.72-2.72Z"
              />
            </svg>
          </span>
        </button>
      </div>
      {error && (
        <p id="newsletter-email-error" className={cx("footer__input-error")}>
          {error}
        </p>
      )}
      {success && <p className={cx("success")}>Thank you for subscribing!</p>}
    </form>
  );
}
